<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative;display:flex;justify-content: space-between;height: 28px;line-height: 28px;">
        <Breadcrumb>
          <BreadcrumbItem to="/home">
            <Icon type="icon iconfont icon-xitong" />
            系统首页
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Icon type="icon iconfont icon-xitonghoutai" />
            系统管理
          </BreadcrumbItem>
          <BreadcrumbItem to="/system/dictiona">
            <Icon type="icon iconfont icon-bianma" />
            企业设备管理
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Icon type="md-build" />
            修改图片
          </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top:12px; ">

        <div class="titlable">
          <span>修改图片</span>
        </div>

        <div class="demo-upload-list" v-for="item2 in uploadList">
          <template v-if="item2.status === 'finished'">
            <img :src="item2.url">
            <div class="demo-upload-list-cover">
              <Icon type="ios-eye-outline" @click.native="handleView(item2.name)"></Icon>
              <Icon type="ios-trash-outline" @click.native="handleRemove(item2)"></Icon>
            </div>
          </template>
          <template v-else>
            <Progress v-if="item2.showProgress" :percent="item2.percentage" hide-info></Progress>
          </template>
        </div>
        <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess"
                :format="['jpg','jpeg','png']" :max-size="2048" multiple type="drag" :headers="uploadHeaders"
                :action="this.ApiUrl+'files/upload5'" style="display: inline-block;width:58px;">
          <div style="width: 58px;height:58px;line-height: 58px;">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </Upload>
        <div class="btnbox">
          <Button size="large" @click="backmast">取消</Button>
          <Button size="large" type="info" @click="addCodeInfo">提交</Button>
        </div>
      </Card>

    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showinfo: false, // 弹出框
      codename: '', // 编码名
      cnname: '', // 中文名
      unit: '', // 单位名
      codeid: '',
      picUrl: '',
      comids: '',
      defaultList: [
        {
          'name': 'a42bdcc1178e62b4694c830f028db5c0',
          'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar',
        },
        {
          'name': 'bc7521e033abdd1e92222d733590f104',
          'url': 'https://o5wwk8baw.qnssl.com/bc7521e033abdd1e92222d733590f104/avatar',
        },
      ],
      imgName: '',
      visible: false,
      uploadList: [],
    };
  },
  created() {
    const id = this.$route;

  },
  computed: {
    uploadHeaders() {
      const token = sessionStorage.getItem('AC_ACCESS_TOKEN');
      return token ? { Authorization: `Bearer ${token}` } : {};
    },
  },
  mounted() {

    const id = this.$route.query.comid;
    const ids = this.$route.query.comids;
    this.picUrl = this.$route.query.url;
    if (this.picUrl == null || this.picUrl == '') {
      this.uploadList = [];
    } else {
      if (this.picUrl.match(',')) {
        let thisUrl = this.picUrl.split(',');
        for (var i = 0; i < thisUrl.length; i++) {
          let url = { 'url': thisUrl[i], 'status': 'finished', 'showProgress': '', 'percentage': '' };
          this.uploadList.push(url);
        }
      } else {
        let url = { 'url': this.picUrl, 'status': 'finished', 'showProgress': '', 'percentage': '' };
        this.uploadList.push(url);
      }
    }

    this.codeid = id;
    this.comids = ids;
    this.getcomidInfo(id);
  },
  methods: {
    getcomidInfo() {

    },
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      let url = {
        'url': res.data[0],
        'status': file.status,
        'showProgress': file.showProgress,
        'percentage': file.percentage,
      };
      this.uploadList.push(url);
    },
    backmast() {
      this.$router.back()
    },
    addCodeInfo() {
      let url = '';
      for (var i = 0; i < this.uploadList.length; i++) {
        if (i < this.uploadList.length - 1) {
          url += (this.uploadList[i].url + ',');
        } else {
          url += this.uploadList[i].url;
        }
      }
      const that = this;
      const api = this.ApiUrl + 'gkEquip/updateGkEquip';
      console.log('this.codeid', this.codeid);
      const data = {
        'picUrl': url,
        'gkEquip_id': this.codeid,
      };
      this.$http.post(api, data).then(res => {

        if (res.data.extend.news == 0) {
          this.$Message.success(`修改成功`);

          setTimeout(()=> {
            this.$router.go(-1)
          }, 1000);
        }
      }, res => {

      });
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.picbox {
  height: 12.5rem;
  width: 12.5rem;
  border: 1px solid #ccc;
}

.titlable {
  height: 24px;
  border-left: 0.125rem solid aquamarine;
  padding-left: 20px;
  line-height: 24px;
  margin-bottom: 20px;
}

.cominfo {
  display: flex;
  flex-direction: column;

}

.inptext {
  margin-top: 0.625rem;
  width: 25rem;
}

.inpuarea {
  margin-top: 0.625rem;
  width: 25rem;

}

.btnbox {
  margin-top: 1.25rem;
  width: 25rem;
  display: flex;
  align-items: flex-start;

}

.btnbox > button {
  margin-right: 10px;
}

.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
  margin-right: 4px;
}

.demo-upload-list img {
  width: 100%;
  height: 100%;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
